<template>
    <div style="margin: 20px">
        <el-card shadow="never">
            <el-table  
            :data="tableData"
            row-key="id" 
            border
            v-loading="tableLoading"
            tooltip-effect="light"
            :stripe="true">
                <el-table-column width="200" show-overflow-tooltip prop="payMeterNo" label="表号"></el-table-column>
                <el-table-column width="250" show-overflow-tooltip prop="actualNo" label="实际表号"></el-table-column>
                <el-table-column width="100" prop="meterType" label="类型"></el-table-column>
                <el-table-column width="160" show-overflow-tooltip prop="roomName" label="房间"></el-table-column>

                <el-table-column width="120" prop="accrualDate" label="应收日期"></el-table-column>
                <el-table-column width="120" prop="beforeNum" label="上期读数"></el-table-column>
                <el-table-column width="120" prop="nowNum" label="本期读数"></el-table-column>
                <el-table-column width="120" prop="beilv" label="倍率"></el-table-column>
                <el-table-column width="120" prop="price" label="单价（元）"></el-table-column>
                <el-table-column width="100" prop="loss" label="线损"></el-table-column>
                <el-table-column width="100" prop="useNum" label="用量"></el-table-column>
                <el-table-column width="120" prop="money" label="金额（元）"></el-table-column>
                <el-table-column width="100" prop="payMoney" label="已缴"></el-table-column>

                <el-table-column width="200" prop="chargeStartDate" label="计费开始日期"></el-table-column>
                <el-table-column width="200" prop="chargeEndDate" label="计费结束日期"></el-table-column>
                <el-table-column width="200" prop="readDate" label="抄表日期"></el-table-column>
                <el-table-column width="200" prop="createDate" label="录入日期"></el-table-column>
                <el-table-column width="100" prop="createByStr" label="录入人"></el-table-column>
                <el-table-column width="100" prop="orderStatusStr" label="生成状态"></el-table-column>
                <el-table-column width="100" prop="payStatusStr" label="销帐状态"></el-table-column>
                <el-table-column width="250" prop="remarks" label="备注"></el-table-column>
            </el-table>
            <simple-pagination @search="doSearch" />
        </el-card>
    </div>
</template>

<script>
import '@/assets/scss/common.scss';
import mixin from '@/mixin';
export default {
    name: "HandworkTable",
    mixins: [mixin],
    props: {
        meterId: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            queryListUrl: '/meter/web/handwork/listPage',
        }
    },
    methods: {
        getSearchParams() {
            return {
                meterId: this.meterId
            };
        },
        doSearch() {
            this.getList();
        }
    },
    mounted() {
        if(this.meterId) {
            this.doSearch();
        }
    }
}
</script>